<template>
  <div>
    <Logo :parentData="pageData" />
    <BackStageMenu :parentData="pageData" />
    <div id="contents" class="clearfix">
      <div id="main_area">
        <div style="clear: both"></div>
        <div class="information">
          <h3>{{ pageData.MenuName }}</h3>
          <div class="table_scroll2">
            <table class="newTable">
              <tbody>
                <tr>
                  <td>申報年度</td>
                  <td colspan="3">
                    <select v-model="form.syear">
                      <option
                        v-for="(data, index) in dropDownList.syears"
                        :key="index"
                        :value="data"
                      >
                        {{ data }}
                      </option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <td>受理申報機關</td>
                  <td colspan="3">
                    <select
                      v-model="form.jobGovCode1"
                      style="min-width: 200px"
                      @change="JobGovCode1Change()"
                      :disabled="
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        1 <= loginInfo.layerNum
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.jobGovCode1s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <select
                      v-model="form.jobGovCode2"
                      style="min-width: 200px"
                      @change="JobGovCode2Change()"
                      :disabled="
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        2 <= loginInfo.layerNum
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.jobGovCode2s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <select
                      v-model="form.jobGovCode3"
                      style="min-width: 200px"
                      @change="JobGovCode3Change()"
                      :disabled="
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        3 <= loginInfo.layerNum
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.jobGovCode3s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <select
                      v-model="form.jobGovCode4"
                      style="min-width: 200px"
                      :disabled="
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        4 <= loginInfo.layerNum
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.jobGovCode4s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <div>
                      <input
                        type="checkbox"
                        v-model="form.jobGovCheck"
                        true-value="1"
                        false-value="0"
                      />
                      包含所屬機關
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>身分證統一編號</td>
                  <td>
                    <input type="text" v-model="form.idn" />
                  </td>
                  <td>姓名</td>
                  <td>
                    <input type="text" v-model="form.name" />
                  </td>
                </tr>
                <tr>
                  <td>匯出格式</td>
                  <td colspan="3">
                    <p>
                      <label>
                        <input
                          type="radio"
                          checked="checked"
                          value="XLSX"
                          v-model="form.printtype"
                        />
                        XLSX</label
                      >
                      <label>
                        <input
                          type="radio"
                          v-model="form.printtype"
                          value="ODS"
                          checked="checked"
                          display
                        />
                        ODS</label
                      >
                    </p>
                  </td>
                </tr>
                <tr>
                  <td colspan="6" class="f_center">
                    <label for="checkbox"
                      ><span>
                        <input
                          type="submit"
                          class="btn"
                          value="查詢"
                          @click="
                            () => {
                              this.form.currentpage = 1;
                              this.form.pagesize = 10;
                              this.doQuery();
                            }
                          "
                        />
                        <input
                          type="submit"
                          class="btn"
                          value="匯出中籤名單"
                          @click="btnExport()"
                        />
                        <input
                          type="submit"
                          class="btn"
                          value="重填"
                          @click="btnClear()"
                        /> </span
                    ></label>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="f_center"></div>
        </div>
        <!-- 查詢結果開始-->
        <div class="information">
          <table width="100%">
            <tbody>
              <tr>
                <td>
                  <input
                    type="submit"
                    class="btn"
                    value="新增中籤名單"
                    @click="btnAdd()"
                  />
                  <input
                    type="submit"
                    class="btn"
                    value="送至M101審查"
                    @click="btnSendM101()"
                  />
                </td>
                <td align="right" v-if="grid.gridDatas">
                  <input
                    type="button"
                    value="<<"
                    class="btn"
                    style="height: 28px"
                    @click="form.currentpage = grid.paginaiton.pageNo - 1"
                    v-show="grid.paginaiton.pageNo > 1"
                  />
                  <span
                    v-for="(data, index) in grid.paginaiton.pages"
                    :key="index"
                    style="cursor: pointer"
                    :style="
                      grid.paginaiton.pageNo == data
                        ? 'color:red'
                        : 'color:black'
                    "
                    @click="form.currentpage = parseInt(data)"
                  >
                    {{
                      grid.paginaiton.pageNo == data ? "[" + data + "]" : data
                    }}
                  </span>
                  <input
                    type="button"
                    class="btn"
                    value=">>"
                    style="height: 28px"
                    v-show="grid.paginaiton.pageNo < grid.paginaiton.totalPage"
                    @click="form.currentpage = grid.paginaiton.pageNo + 1"
                  />
                  ［每頁<input
                    type="text"
                    v-model.number.lazy="form.pagesize"
                    size="2"
                    maxlength="4"
                  />

                  <input type="button" class="btn" value="筆" />，第<input
                    type="text"
                    v-model.number.lazy="form.currentpage"
                    size="2"
                    maxlength="4"
                  />
                  <input type="button" class="btn" value="頁" />，共
                  {{ grid.paginaiton.totalPage }} 頁
                  {{ grid.paginaiton.totalCount }} 筆］
                </td>
              </tr>
            </tbody>
          </table>
          <div class="active">
            <div class="table_scroll2">
              <table width="1060" class="itable">
                <thead>
                  <tr>
                    <th>操作</th>
                    <th>項次</th>
                    <th>
                      <u
                        style="cursor: pointer"
                        target="_blank"
                        @click="
                          () => {
                            this.reQuery('NAME', Sort);
                          }
                        "
                        >姓名</u
                      >
                    </th>
                    <th>
                      <u
                        style="cursor: pointer"
                        target="_blank"
                        @click="
                          () => {
                            this.reQuery('IDN', Sort);
                          }
                        "
                        >身分證統一編號</u
                      >
                    </th>
                    <th>
                      <u
                        style="cursor: pointer"
                        target="_blank"
                        @click="
                          () => {
                            this.reQuery('GOV_CODE', Sort);
                          }
                        "
                        >受理申報機關</u
                      >
                    </th>
                    <th>
                      <u
                        style="cursor: pointer"
                        target="_blank"
                        @click="
                          () => {
                            this.reQuery('SurveyDay', Sort);
                          }
                        "
                        >申報日</u
                      >
                    </th>
                    <th>
                      <u
                        style="cursor: pointer"
                        target="_blank"
                        @click="
                          () => {
                            this.reQuery('AUTH_SEQ', Sort);
                          }
                        "
                        >是否已送至<br />M101審查</u
                      >
                    </th>
                    <th>
                      <u
                        style="cursor: pointer"
                        target="_blank"
                        @click="
                          () => {
                            this.reQuery('isVerifyYear', Sort);
                          }
                        "
                        >前後年比對註記</u
                      >
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(data, index) in grid.gridDatas" :key="index">
                    <td width="1%" align="center">
                      <input
                        type="button"
                        class="btn"
                        value="刪"
                        @click="btnDelete(data)"
                        v-if="data.autH_STR != '已送出'"
                      /><!--:disabled="data.autH_STR == '已送出'"-->
                      <input
                        type="button"
                        class="btn"
                        value="刪"
                        disabled
                        v-else
                      />
                    </td>
                    <td>{{ index + 1 }}</td>
                    <td>{{ data.name }}</td>
                    <td>{{ data.idn }}</td>
                    <td>{{ data.govname }}</td>
                    <td>
                      <DatePicker
                        v-model="grid.gridDatas[index].sdatestr"
                        format="YYYMMDD"
                        :isTaiwanYear="true"
                        clearable
                        placeholder="請輸入/選擇日期"
                        :disabled="data.autH_STR == '已送出'"
                        @input="btnUpdateSDateCheck(data, 'change')"
                      />
                      <!-- <input type="button"
                                    class="btn"
                                    value="確認"
                                    v-if="data.surveydaY_STR == ''"
                                    @click="btnUpdateSDate(data)" />  -->
                    </td>
                    <td>{{ data.autH_STR }}</td>
                    <td>{{ data.isverifyyear }}</td>
                  </tr>
                  <tr
                    v-if="
                      !(grid && grid.gridDatas && grid.gridDatas.length > 0)
                    "
                  >
                    <td colspan="7" style="text-align: center">查無資料</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- 查詢結果結束-->
        </div>
      </div>
    </div>
    <PdisFooter />

    <AddModal
      v-model="AddModal.show"
      :title="AddModal.title"
      :modalStyle="{ 'max-width': '1200px' }"
    >
      <div class="information">
        <div class="table_scroll2">
          <table class="newTable">
            <tbody>
              <tr>
                <td>申報年度</td>
                <td>
                  <select v-model="AddModal.form.syear" disabled>
                    <option
                      v-for="(data, index) in AddModal.dropDownList.syears"
                      :key="index"
                      :value="data"
                    >
                      {{ data }}
                    </option>
                  </select>
                </td>
              </tr>
              <tr>
                <td>受理申報機關</td>
                <td colspan="3">
                  <select
                    v-model="AddModal.form.jobGovCode1"
                    style="min-width: 200px"
                    @change="AddModalJobGovCode1Change()"
                    :disabled="
                      loginInfo &&
                      loginInfo.roleSeq != 1 &&
                      1 <= loginInfo.layerNum
                    "
                  >
                    <option
                      v-for="(item, index) in AddModal.dropDownList
                        .jobGovCode1s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                  <select
                    v-model="AddModal.form.jobGovCode2"
                    style="min-width: 200px"
                    @change="AddModalJobGovCode2Change()"
                    :disabled="
                      loginInfo &&
                      loginInfo.roleSeq != 1 &&
                      2 <= loginInfo.layerNum
                    "
                  >
                    <option
                      v-for="(item, index) in AddModal.dropDownList
                        .jobGovCode2s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                  <select
                    v-model="AddModal.form.jobGovCode3"
                    style="min-width: 200px"
                    @change="AddModalJobGovCode3Change()"
                    :disabled="
                      loginInfo &&
                      loginInfo.roleSeq != 1 &&
                      3 <= loginInfo.layerNum
                    "
                  >
                    <option
                      v-for="(item, index) in AddModal.dropDownList
                        .jobGovCode3s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                  <select
                    v-model="AddModal.form.jobGovCode4"
                    style="min-width: 200px"
                    :disabled="
                      loginInfo &&
                      loginInfo.roleSeq != 1 &&
                      4 <= loginInfo.layerNum
                    "
                  >
                    <option
                      v-for="(item, index) in AddModal.dropDownList
                        .jobGovCode4s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                  <div>
                    <input
                      type="checkbox"
                      v-model="AddModal.form.jobGovCheck"
                      true-value="1"
                      false-value="0"
                    />
                    包含所屬機關
                  </div>
                </td>
              </tr>
              <tr>
                <td>姓名或身分證統一編號</td>
                <td><input type="text" v-model="AddModal.form.idn" /></td>
              </tr>
              <tr>
                <td>是否前後年財產比對</td>
                <td>
                  <p>
                    <label>
                      <input
                        type="radio"
                        v-model="AddModal.form.isVerifyYear"
                        value="Y"
                      />
                      是
                    </label>
                    <label>
                      <input
                        type="radio"
                        v-model="AddModal.form.isVerifyYear"
                        value="N"
                      />
                      否</label
                    >
                  </p>
                </td>
              </tr>
              <tr>
                <td colspan="4" class="f_center">
                  <label for="checkbox"
                    ><span>
                      <input
                        type="submit"
                        class="btn"
                        value="挑選入中籤名單"
                        @click="AddModalBtnPick()"
                      />
                      <input
                        type="submit"
                        class="btn"
                        value="重填"
                        @click="AddModalBtnClear()"
                      /> </span
                  ></label>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="f_center"></div>
      </div>
    </AddModal>

    <Alert v-model="Alert.show" :title="Alert.title">
      <div style="text-align: center">
        <div
          v-for="(data, index) in Alert.txt"
          :key="index"
          style="margin-bottom: 10px"
        >
          <p>{{ data }}</p>
        </div>
        <div>
          <button class="btn" @click="Alert.BtnConfirm">確定</button>
        </div>
      </div>
    </Alert>
    <AlertDel v-model="AlertDel.show" :title="AlertDel.title">
      <div style="text-align: center">
        <p>確定要刪除資料嗎?</p>
        <div>
          <button class="btn" @click="btnDelSubmit()">確定</button>
          <button class="btn" @click="AlertDel.show = false">取消</button>
        </div>
      </div>
    </AlertDel>
    <AlertBtn
      v-model="AlertBtn.show"
      :title="AlertBtn.title"
      :enableClose="false"
    >
      <div style="text-align: center">
        <p>
          請依申報人中籤之申報表「申報日」、「申報種類」、「上傳日期」後，確認F102及C101資料是否正確一致。
          此資料將影響後續送審及實質審查等相關功能，是否確定修改？
        </p>
        <div>
          <button class="btn" @click="btnUpdateSDate(AlertBtn.form)">
            確定
          </button>
          <button class="btn" @click="btnUpdateSDateCheck(AlertBtn.form, 'no')">
            取消
          </button>
        </div>
      </div>
    </AlertBtn>
  </div>
</template>

<script>
import VueModal from "@/components/Common/vue-modal.vue";
import VueDatepicker from "@/components/Common/VueDatepickerLocal";
import Logo from "@/components/Common/Logo.vue";
import BackStageMenu from "@/components/BackStage/BackStageMenu.vue";
import PdisFooter from "@/components/Common/PdisFooter.vue";
import { ChkIDorRCNumber, getMenuIndex, getMenu } from "@/config/util.js";
import {
  SearchGovCode,
  F102_SearchGrid,
  F102_ReSearchGrid,
  F102_PrintReport,
  F102_Delete,
  F102_DetailAddSave,
  F102_SendToM101,
  F102_DetailEditSave
} from "@/service/api.js";
export default {
  name: "F102",
  data: function () {
    return {
      pageData: {
        MenuIndex: 4,
        MenuName: "",
        PrgName: "F102",
        ServiceUnit: "PDIS",
        isForceLoginOut: true,
      },
      loginInfo: JSON.parse(sessionStorage.getItem("LoginInfo"))
        ? JSON.parse(sessionStorage.getItem("LoginInfo"))
        : "",
      SessionGovCode: sessionStorage.getItem("Session_GovCode"),
      Order: "",
      Sort: "",
      tempDate: "",
      form: {
        syear: String(new Date().getFullYear() - 1911 - 1),
        idn: "",
        name: "",
        jobGovCode1: "",
        jobGovCode2: "",
        jobGovCode3: "",
        jobGovCode4: "",
        jobGovCheck: "0",
        // ImportType: "XLSX",
        pagesize: 10,
        currentpage: 1,
        printtype: "XLSX",
      },
      grid: [],
      sendauthdata: [],
      dropDownList: {
        jobGovCode1s: [],
        jobGovCode2s: [],
        jobGovCode3s: [],
        jobGovCode4s: [],
        syears: [],
      },
      AddModal: {
        show: false,
        title: "",
        form: {
          syear: String(new Date().getFullYear() - 1911 - 1),
          jobGovCode1: "",
          jobGovCode2: "",
          jobGovCode3: "",
          jobGovCode4: "",
          jobGovCheck: "0",
          idn: "",
          isVerifyYear: "N",
        },
        dropDownList: {
          syears: [],
          jobGovCode1s: [],
          jobGovCode2s: [],
          jobGovCode3s: [],
          jobGovCode4s: [],
        },
      },
      Alert: {
        show: false,
        title: "",
        txt: [],
        BtnConfirm: function () {
          this.show = false;
        },
      },
      AlertDel: {
        show: false,
        title: "",
        form: {
          pkno: 0,
        },
      },
      AlertBtn: {
        show: false,
        title: "",
        form: {},
      },
      host: window.location.host,
    };
  },
  components: {
    Logo,
    BackStageMenu,
    PdisFooter,
    Alert: VueModal,
    AlertDel: VueModal,
    AlertBtn: VueModal,
    AddModal: VueModal,
    DatePicker: VueDatepicker,
  },
  methods: {
    //取得受理申報機關第一層類別
    getSearchJobGovCode1: function () {
      const self = this;
      let GovCode = { UP_GOV_CODE: "", LAYER_NUM: "1", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.jobGovCode1s = rData.returnObject;
      });
    },
    //取得受理申報機關第二層類別
    getSearchJobGovCode2: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "2", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.jobGovCode2s = rData.returnObject;
      });
    },
    //取得受理申報機關第三層類別
    getSearchJobGovCode3: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "3", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.jobGovCode3s = rData.returnObject;
      });
    },
    //取得受理申報機關第四層類別
    getSearchJobGovCode4: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "4", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.jobGovCode4s = rData.returnObject;
      });
    },
    getSyearDropDownList: function () {
      let syears = [];
      const startYear = 99; //民國99年
      for (let i = startYear; i <= new Date().getFullYear() - 1911; i++) {
        syears.push(i.toString().length === 2 ? "0" + i : i.toString());
      }
      return syears;
    },
    //取得受理申報機關第一層類別 AddModal
    AddModalGetSearchJobGovCode1: function () {
      const self = this;
      let GovCode = { UP_GOV_CODE: "", LAYER_NUM: "1", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.AddModal.dropDownList.jobGovCode1s = rData.returnObject;
      });
    },
    //取得受理申報機關第二層類別 AddModal
    AddModalGetSearchJobGovCode2: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "2", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.AddModal.dropDownList.jobGovCode2s = rData.returnObject;
      });
    },
    //取得受理申報機關第三層類別 AddModal
    AddModalGetSearchJobGovCode3: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "3", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.AddModal.dropDownList.jobGovCode3s = rData.returnObject;
      });
    },
    //取得受理申報機關第四層類別 AddModal
    AddModalGetSearchJobGovCode4: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "4", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.AddModal.dropDownList.jobGovCode4s = rData.returnObject;
      });
    },
    AddModalGetSyearDropDownList: function () {
      let syears = [];
      const startYear = 99; //民國99年
      for (let i = startYear; i <= new Date().getFullYear() - 1911; i++) {
        syears.push(i.toString().length === 2 ? "0" + i : i.toString());
      }
      return syears;
    },
    //查詢
    doQuery: function () {
      const self = this;
      //清空
      self.Order = "";
      self.Sort = "";
      if (!self.checkPage(self.form.currentpage, self.form.pagesize)) return;
      let postData = {
        idn: self.form.idn,
        name: self.form.name,
        syear: self.form.syear,
        goV_CODE: self.form.jobGovCode4
          ? self.form.jobGovCode4
          : self.form.jobGovCode3
          ? self.form.jobGovCode3
          : self.form.jobGovCode2
          ? self.form.jobGovCode2
          : self.form.jobGovCode1
          ? self.form.jobGovCode1
          : "",
        GOVCHECK: parseInt(self.form.jobGovCheck),
        loT_MAN_GOV: self.loginInfo ? self.loginInfo.govCode : "",
        loT_MAN_GOV_STR: self.loginInfo ? self.loginInfo.govCodeStr : "",
        //ImportType: "XLSX",  //"XLSX" OR "ODS"
        currentpage: self.form.currentpage,
        pagesize: self.form.pagesize,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "查詢",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      F102_SearchGrid(postData).then((rData) => {
        self.grid = rData.returnObject;
        self.grid.gridDatas.forEach(function (item, index, array) {
          debugger;
          if (item.surveydaY_STR != "") {
            var a = String(parseInt(item.surveydaY_STR.substring(0, 3)) + 1911);
            var b = item.surveydaY_STR.substring(3, 5);
            var c = item.surveydaY_STR.substring(5);
            item.sdatestr = a + "/" + b + "/" + c;
          } else if(item.lotterY_SURVEYDAY_STR != ""){
            var a = String(parseInt(item.lotterY_SURVEYDAY_STR.substring(0, 3)) + 1911);
            var b = item.lotterY_SURVEYDAY_STR.substring(3, 5);
            var c = item.lotterY_SURVEYDAY_STR.substring(5);
            item.sdatestr = a + "/" + b + "/" + c;
          }
          else {
            if (item.sdate == null || item.sdate == "") {
              item.sdatestr = "";
            } else {
              var a = String(parseInt(item.sdate.substring(0, 3)) + 1911);
              var b = item.sdate.substring(3, 5);
              var c = item.sdate.substring(5);
              item.sdatestr = a + "/" + b + "/" + c;
            }
          }
        });
      });
    },
    reQuery: function (NM, SC) {
      const self = this;
      if (NM == "" && SC == "") {
        if (self.Order == "" && self.Sort == "") {
          //所謂預設值
          self.Order = "IDN";
          self.Sort = "ASC";
        } else {
          //換頁 self.Order && self.Sort 維持原樣
        }
      } else if (NM == self.Order) {
        //而後的點擊
        if (SC == "ASC") {
          self.Sort = "DESC";
        } else {
          self.Sort = "ASC";
        }
      } else {
        //第一次的點擊
        self.Order = NM;
        self.Sort = "ASC";
      }
      if (!self.checkPage(self.form.currentpage, self.form.pagesize)) return;
      let postData = {
        idn: self.form.idn,
        name: self.form.name,
        syear: self.form.syear,
        goV_CODE: self.form.jobGovCode4
          ? self.form.jobGovCode4
          : self.form.jobGovCode3
          ? self.form.jobGovCode3
          : self.form.jobGovCode2
          ? self.form.jobGovCode2
          : self.form.jobGovCode1
          ? self.form.jobGovCode1
          : "",
        GOVCHECK: parseInt(self.form.jobGovCheck),
        loT_MAN_GOV: self.loginInfo ? self.loginInfo.govCode : "",
        loT_MAN_GOV_STR: self.loginInfo ? self.loginInfo.govCodeStr : "",
        //ImportType: "XLSX",  //"XLSX" OR "ODS"
        currentpage: self.form.currentpage,
        pagesize: self.form.pagesize,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "查詢",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
        SORT: self.Sort,
        ORDER: self.Order,
      };
      F102_ReSearchGrid(postData).then((rData) => {
        self.grid = rData.returnObject;
        self.grid.gridDatas.forEach(function (item, index, array) {
          if (item.surveydaY_STR != "") {
            var a = String(parseInt(item.surveydaY_STR.substring(0, 3)) + 1911);
            var b = item.surveydaY_STR.substring(3, 5);
            var c = item.surveydaY_STR.substring(5);
            item.sdatestr = a + "/" + b + "/" + c;
          } else if(item.lotterY_SURVEYDAY_STR != ""){
            var a = String(parseInt(item.lotterY_SURVEYDAY_STR.substring(0, 3)) + 1911);
            var b = item.lotterY_SURVEYDAY_STR.substring(3, 5);
            var c = item.lotterY_SURVEYDAY_STR.substring(5);
            item.sdatestr = a + "/" + b + "/" + c;
          }
          else {
            if (item.sdate == null || item.sdate == "") {
              item.sdatestr = "";
            } else {
              var a = String(parseInt(item.sdate.substring(0, 3)) + 1911);
              var b = item.sdate.substring(3, 5);
              var c = item.sdate.substring(5);
              item.sdatestr = a + "/" + b + "/" + c;
            }
          }
        });
      });
    },
    //匯出中籤名單
    btnExport: function () {
      const self = this;
      let postData = {
        syear: self.form.syear,
        idn: self.form.idn,
        name: self.form.name,
        loT_MAN_GOV: self.loginInfo ? self.loginInfo.govCode : "",
        loT_MAN_GOV_STR: self.loginInfo ? self.loginInfo.govCodeStr : "",
        goV_CODE: self.form.jobGovCode4
          ? self.form.jobGovCode4
          : self.form.jobGovCode3
          ? self.form.jobGovCode3
          : self.form.jobGovCode2
          ? self.form.jobGovCode2
          : self.form.jobGovCode1
          ? self.form.jobGovCode1
          : "",
        govcheck: parseInt(self.form.jobGovCheck),
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "匯出中籤名單",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
        printtype: self.form.printtype,
      };
      console.log(JSON.stringify(postData));

      if (self.form.printtype == "ODS") {
        F102_PrintReport(postData).then((rData) => {
          if (rData) {
            let link = document.createElement("a");
            link.download = "F102.ods";
            link.href = "data:application/doc;base64," + rData;
            link.click();
          } else {
            self.Alert.show = true;
            self.Alert.title = "訊息";
            self.Alert.txt = ["無資料匯出"];
            self.Alert.BtnConfirm = () => {
              self.Alert.show = false;
            };
          }
        });
      } else {
        F102_PrintReport(postData).then((rData) => {
          if (rData) {
            let link = document.createElement("a");
            link.download = "F102.xlsx";
            link.href = "data:application/vnd.ms-excel;base64," + rData;
            link.click();
          } else {
            self.Alert.show = true;
            self.Alert.title = "錯誤";
            self.Alert.txt = ["無資料匯出"];
            self.Alert.BtnConfirm = () => (self.Alert.show = false);
          }
        });
      }
    },
    //重填
    btnClear: function () {
      const self = this;
      self.form = {
        syear: String(new Date().getFullYear() - 1911 - 1),
        idn: "",
        name: "",
        jobGovCode1: "",
        jobGovCode2: "",
        jobGovCode3: "",
        jobGovCode4: "",
        jobGovCheck: "0",
        //ImportType: "XLSX",
        printtype: "XLSX",
        pagesize: 10,
        currentpage: 1,
      };
      self.JobGovCodeInit(self.form);
      self.getSearchJobGovCode1();
    },
    JobGovCodeInit: function (form) {
      const self = this;
      if (self.SessionGovCode != null) {
        form.jobGovCode1 = self.SessionGovCode;
        form.jobGovCode2 = "";
        form.jobGovCode3 = "";
        form.jobGovCode4 = "";
      } else {
        if (self.loginInfo) {
          let govCodeArray = self.loginInfo.govCodeStr.split(",");
          form.jobGovCode1 = govCodeArray[0];
          form.jobGovCode2 = govCodeArray[1];
          form.jobGovCode3 = govCodeArray[2];
          form.jobGovCode4 = govCodeArray[3];
        }
      }
    },
    JobGovCode1Change: function () {
      const self = this;
      self.form.jobGovCode2 = "";
      self.form.jobGovCode3 = "";
      self.form.jobGovCode4 = "";
      self.dropDownList.jobGovCode2s = [];
      self.dropDownList.jobGovCode3s = [];
      self.dropDownList.jobGovCode4s = [];
    },
    JobGovCode2Change: function () {
      const self = this;
      self.form.jobGovCode3 = "";
      self.form.jobGovCode4 = "";
      self.dropDownList.jobGovCode3s = [];
      self.dropDownList.jobGovCode4s = [];
    },
    JobGovCode3Change: function () {
      const self = this;
      self.form.jobGovCode4 = "";
      self.dropDownList.jobGovCode4s = [];
    },
    AddModalJobGovCode1Change: function () {
      const self = this;
      self.AddModal.form.jobGovCode2 = "";
      self.AddModal.form.jobGovCode3 = "";
      self.AddModal.form.jobGovCode4 = "";
      self.AddModal.dropDownList.jobGovCode2s = [];
      self.AddModal.dropDownList.jobGovCode3s = [];
      self.AddModal.dropDownList.jobGovCode4s = [];
    },
    AddModalJobGovCode2Change: function () {
      const self = this;
      self.AddModal.form.jobGovCode3 = "";
      self.AddModal.form.jobGovCode4 = "";
      self.AddModal.dropDownList.jobGovCode3s = [];
      self.AddModal.dropDownList.jobGovCode4s = [];
    },
    AddModalJobGovCode3Change: function () {
      const self = this;
      self.AddModal.form.jobGovCode4 = "";
      self.AddModal.dropDownList.jobGovCode4s = [];
    },
    //刪
    btnUpdateSDateCheck: function (data, result) {
      const self = this;
      debugger;
      if (result == "no") {
        if (data.sdate == null || data.sdate == "") {
          data.sdatestr = "";
        } else {
          var a = String(parseInt(data.sdate.substring(0, 3)) + 1911);
          var b = data.sdate.substring(3, 5);
          var c = data.sdate.substring(5);
          data.sdatestr = a + "/" + b + "/" + c;
        }
        this.AlertBtn.show = false;
        this.AlertBtn.title = "提醒";
        this.AlertBtn.form = data;

        return;
      }
      else{
        var a = data.sdatestr.getFullYear();
        var b = data.sdatestr.getMonth() + 1;
        var c = data.sdatestr.getDate();
        data.sdatestr = a + "/" + b + "/" + c;
      }

      this.AlertBtn.show = true;
      this.AlertBtn.title = "提醒";
      this.AlertBtn.form = data;
    },
    btnUpdateSDate: function (data) {
      const self = this;
      debugger;
      this.AlertBtn.show = false;
      if (data.sdatestr == "") {
        self.Alert.show = true;
        self.Alert.title = "錯誤";
        self.Alert.txt = ["請輸入申報日期"];
        self.Alert.BtnConfirm = () => (self.Alert.show = false);
      } else if (self.sendauthdata.length > 0) {
        self.sendauthdata.forEach((g) => {
          if (
            g.idn == data.idn &&
            g.goV_CODE == data.govcode &&
            g.syear == data.syear
          ) {
            g.sdate = data.sdate;
            g.sdatestr = data.sdatestr;
          } else {
            self.sendauthdata.push({
              syear: data.syear,
              idn: data.idn,
              goV_CODE: data.govcode,
              sdate: data.sdate,
              sdatestr: data.sdatestr,
            });
          }
        });
        F102_DetailEditSave({
        pkno: data.pkno,
        sdatestr: data.sdatestr,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "儲存",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      }).then((rData) => {
        if (rData.result) {
          self.Alert.show = true;
          self.Alert.title = "訊息";
          self.Alert.txt = ["儲存成功"];
          self.Alert.BtnConfirm = () => {
            self.Alert.show = false;
            self.AlertDel.show = false;
            self.doQuery();
          };
        } else {
          self.Alert.show = true;
          self.AlertDel.show = false;
          self.Alert.title = "訊息";
          self.Alert.txt = ["儲存失敗"];
          self.Alert.txt = rData.messages;
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
      });
      } else {
        self.sendauthdata.push({
          syear: data.syear,
          idn: data.idn,
          goV_CODE: data.govcode,
          surveydaY_STR: data.sdate,
          sdatestr: data.sdatestr,
        });
        F102_DetailEditSave({
        pkno: data.pkno,
        sdatestr: data.sdatestr,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "儲存",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      }).then((rData) => {
        if (rData.result) {
          self.Alert.show = true;
          self.Alert.title = "訊息";
          self.Alert.txt = ["儲存成功"];
          self.Alert.BtnConfirm = () => {
            self.Alert.show = false;
            self.AlertDel.show = false;
            self.doQuery();
          };
        } else {
          self.Alert.show = true;
          self.AlertDel.show = false;
          self.Alert.title = "訊息";
          self.Alert.txt = ["儲存失敗"];
          self.Alert.txt = rData.messages;
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
      });
      }
    },
    //分頁防呆檢查
    checkPage: function (currentpage, pagesize) {
      const self = this;
      let pageErrorMsg = [];
      if (currentpage) {
        if (isNaN(parseInt(currentpage))) {
          pageErrorMsg.push("頁數格式錯誤");
        }
      } else {
        pageErrorMsg.push("請填寫頁數");
      }
      if (pagesize) {
        if (isNaN(parseInt(pagesize))) {
          pageErrorMsg.push("筆數格式錯誤");
        }
      } else {
        pageErrorMsg.push("請填寫每頁筆數");
      }
      if (pageErrorMsg.length) {
        self.Alert.show = true;
        self.Alert.title = "錯誤";
        self.Alert.txt = pageErrorMsg;
        self.Alert.BtnConfirm = () => {
          self.Alert.show = false;
        };
        return false;
      }
      return true;
    },
    //刪
    btnDelete: function (data) {
      const self = this;
      this.AlertDel.show = true;
      this.AlertDel.title = "提醒";
      this.AlertDel.form.pkno = data.pkno;
    },
    btnDelSubmit: function () {
      const self = this;
      F102_Delete({
        pkno: this.AlertDel.form.pkno,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "刪除",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      }).then((rData) => {
        if (rData.result) {
          self.Alert.show = true;
          self.Alert.title = "訊息";
          self.Alert.txt = ["刪除成功"];
          self.Alert.BtnConfirm = () => {
            self.Alert.show = false;
            self.AlertDel.show = false;
            self.doQuery();
          };
        } else {
          self.Alert.show = true;
          self.AlertDel.show = false;
          self.Alert.title = "錯誤";
          //self.Alert.txt = "刪除錯誤";
          self.Alert.txt = rData.messages;
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
      });
    },
    //新增中籤名單
    btnAdd: function () {
      const self = this;
      self.AddModal.dropDownList.syears = self.AddModalGetSyearDropDownList();
      self.JobGovCodeInit(self.AddModal.form);
      self.AddModalGetSearchJobGovCode1();
      self.AddModal.show = true;
      self.AddModal.title = "F102中籤名單維護-新增";
    },
    //送至M101審查
    btnSendM101: function () {
      const self = this;
      let postData = {
        syear: self.form.syear,
        idn: self.form.idn,
        name: self.form.name,
        loT_MAN_GOV: self.loginInfo ? self.loginInfo.govCode : "",
        loT_MAN_GOV_STR: self.loginInfo ? self.loginInfo.govCodeStr : "",
        goV_CODE: self.form.jobGovCode4
          ? self.form.jobGovCode4
          : self.form.jobGovCode3
          ? self.form.jobGovCode3
          : self.form.jobGovCode2
          ? self.form.jobGovCode2
          : self.form.jobGovCode1
          ? self.form.jobGovCode1
          : "",
        govcheck: parseInt(self.form.jobGovCheck),
        sendauthdata: self.sendauthdata,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "送至M101審查",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      Object.keys(postData).map(
        (k) =>
          (postData[k] =
            typeof postData[k] == "string" ? postData[k].trim() : postData[k])
      );
      console.log(JSON.stringify(postData));
      F102_SendToM101(postData).then((rData) => {
        if (rData.result) {
          self.Alert.show = true;
          self.Alert.title = "訊息";
          self.Alert.txt = ["送至M101審查成功"];
          self.Alert.BtnConfirm = () => {
            self.doQuery();
            self.Alert.show = false;
          };
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = rData.messages;
          //self.Alert.txt = "送至M101審查失敗";
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
      });
    },
    //第二頁挑選入中籤名單
    AddModalBtnPick: function () {
      const self = this;
      if (self.AddModal.form.idn.trim() == "") {
        self.Alert.show = true;
        self.Alert.title = "錯誤";
        self.Alert.txt = ["請填寫身分證統一編號"];
        self.Alert.BtnConfirm = () => (self.Alert.show = false);
        return;
      }

      let postData = {
        lotManGov: self.loginInfo ? self.loginInfo.govCode : "",
        lotManGovStr: self.loginInfo ? self.loginInfo.govCodeStr : "",
        govCodeStr:
          self.AddModal.form.jobGovCode1 +
          "," +
          self.AddModal.form.jobGovCode2 +
          "," +
          self.AddModal.form.jobGovCode3 +
          "," +
          self.AddModal.form.jobGovCode4,
        govCode: self.AddModal.form.jobGovCode4
          ? self.AddModal.form.jobGovCode4
          : self.AddModal.form.jobGovCode3
          ? self.AddModal.form.jobGovCode3
          : self.AddModal.form.jobGovCode2
          ? self.AddModal.form.jobGovCode2
          : self.AddModal.form.jobGovCode1
          ? self.AddModal.form.jobGovCode1
          : "",
        govCheck: parseInt(self.AddModal.form.jobGovCheck),
        idn: self.AddModal.form.idn,
        syear: self.AddModal.form.syear,
        rank: "", // 國防部專用
        isVerifyYear: self.AddModal.form.isVerifyYear,
        updateUserId: self.loginInfo ? self.loginInfo.id : "",
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "挑選入中籤名單",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      Object.keys(postData).map(
        (k) =>
          (postData[k] =
            typeof postData[k] == "string" ? postData[k].trim() : postData[k])
      );
      F102_DetailAddSave(postData).then((rData) => {
        if (rData.result) {
          self.Alert.show = true;
          self.Alert.title = "訊息";
          self.Alert.txt = ["寫入中籤名單成功"];
          self.Alert.BtnConfirm = () => {
            self.Alert.show = false;
            self.AddModalBtnClear();
            self.doQuery();
          };
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = rData.messages;
          //self.Alert.txt = "寫入中籤名單失敗";
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
      });
    },
    //第二頁重填
    AddModalBtnClear: function () {
      const self = this;
      self.AddModal.form = {
        syear: String(new Date().getFullYear() - 1911 - 1),
        jobGovCode1: "",
        jobGovCode2: "",
        jobGovCode3: "",
        jobGovCode4: "",
        idn: "",
        isVerifyYear: "N",
        jobGovCheck: 0,
      };
      self.JobGovCodeInit(self.AddModal.form);
      self.AddModalGetSearchJobGovCode1();
    },
  },
  watch: {
    "form.jobGovCode1": function (newValue, oldValue) {
      if (newValue != "") this.getSearchJobGovCode2(newValue);
    },
    "form.jobGovCode2": function (newValue, oldValue) {
      if (newValue != "") this.getSearchJobGovCode3(newValue);
    },
    "form.jobGovCode3": function (newValue, oldValue) {
      if (newValue != "") this.getSearchJobGovCode4(newValue);
    },
    "form.currentpage": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.reQuery("", "");
      }
    },
    "form.pagesize": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.reQuery("", "");
      }
    },
    "AddModal.form.jobGovCode1": function (newValue, oldValue) {
      if (newValue != "") this.AddModalGetSearchJobGovCode2(newValue);
    },
    "AddModal.form.jobGovCode2": function (newValue, oldValue) {
      if (newValue != "") this.AddModalGetSearchJobGovCode3(newValue);
    },
    "AddModal.form.jobGovCode3": function (newValue, oldValue) {
      if (newValue != "") this.AddModalGetSearchJobGovCode4(newValue);
    },
    "AddModal.form.idn": function (newValue, oldValue) {
      const self = this;
      if (newValue != oldValue) {
        self.AddModal.form.idn = newValue.toUpperCase();
      }
    },
  },
  created() {
    const self = this;
    //RoleAuthorizeMenu
    const Menu = getMenu(self.pageData.PrgName);
    if (Menu) {
      self.pageData.MenuIndex = Menu.menuIndex;
      self.pageData.MenuName = Menu.menuName;
    } else {
      self.Alert.show = true;
      self.Alert.title = "訊息";
      self.Alert.txt = ["無進入此頁權限，請洽詢管理員!!"];
      self.Alert.BtnConfirm = () => {
        self.Alert.show = false;
        self.$router.go(-1);
      };
    }
    //self.doinit();
    self.dropDownList.syears = self.getSyearDropDownList();
    self.JobGovCodeInit(self.form);
    self.getSearchJobGovCode1();
    //self.doQuery();
  },
};
</script>

<style scoped src="@/assets/css/Pdis.css" />
